import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GiSpy } from "react-icons/gi";
import CustomLink from "./customLink";
import { FaArrowRight, FaPowerOff } from "react-icons/fa";
import { IoMdArrowDropdown } from "react-icons/io";
import { motion } from "framer-motion";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Track menu state
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown
  const username = localStorage.getItem("username") || "User"; // Retrieve username

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    navigate("/login");
  };

  return (
    <nav className="bg-bg text-white px-6 py-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <GiSpy className="text-5xl text-fg" />
          <h1 className="text-2xl font-bold text-white">
            <Link to="/">KeySpyder</Link>
          </h1>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex align-center items-center space-x-6">
          <Link to="/" className="hover:text-gray-400 transition">
            Home
          </Link>
          <Link to="/about" className="hover:text-gray-400 transition">
            About
          </Link>

          {localStorage.getItem("token") ? (
            <div className="relative">
              <button
                className="flex align-center items-center hover:text-fg hover:cursor-pointer transition"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Welcome, {username}
                <IoMdArrowDropdown size={25} />
              </button>
              {dropdownOpen && (
                <motion.div
                  className="absolute right-0 mt-2 bg-white rounded-md shadow-lg z-10"
                  initial={{ opacity: 0, y: 0 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <CustomLink
                    text={"Logout"}
                    button={true}
                    iconRight={<FaPowerOff />}
                    iconSize={20}
                    viewport={{ once: false }}
                    onClick={handleLogout}
                  ></CustomLink>
                </motion.div>
              )}
            </div>
          ) : (
            <div>
              <CustomLink
                text={"Login"}
                button={true}
                iconRight={<FaArrowRight iconSize={20} />}
                link="/login"
              ></CustomLink>
            </div>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white text-2xl focus:outline-none"
          onClick={() => setIsOpen(!isOpen)} // Toggle menu
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all ${isOpen ? "block" : "hidden"
          } bg-gray-800 p-4`}
      >
        <Link
          to="/"
          className="block py-2 hover:text-gray-400"
          onClick={() => setIsOpen(false)}
        >
          Home
        </Link>
        <Link
          to="/about"
          className="block py-2 hover:text-gray-400"
          onClick={() => setIsOpen(false)}
        >
          About
        </Link>
        <div>
          <CustomLink
            text={"Login"}
            button={true}
            iconRight={<FaArrowRight />}
            link="/login"
          ></CustomLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
